module.exports = __webpack_public_path__ + "static/media/3.3241d8f6.svg";